module.exports = __webpack_public_path__ + "media/images/top/ranking-sample08-b7269b1abf0df6e9ba308acbcc80306f.jpg";